export default __webpack_public_path__ + "assets/img/iconJob.46d81ada1924a111dbd98cef27a9b793.png";